<template>
  <div>
    <div class="white-section">
      <div class="d-flex justify-content-end mb-2" style="align-items: center">
        <div style="margin-left: auto" class="page-title">
          <b-breadcrumb-item
            v-for="item in breadcrumb"
            :key="item.text"
            :active="item.active"
            class="bread-crumb"
          >
            <div v-if="item.active">
              {{ item.translate ? $t(`navigation.${item.text}`) : item.text }}
            </div>
          </b-breadcrumb-item>
        </div>
            <div class="d-flex align-items-center mr-1">
              <b-form-input
                v-model="searchTerm"
                :placeholder="$t('general.search')"
                type="text"
                class="d-inline-block"
              />
            </div>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          size=""
          type="submit"
          variant="info"
          @click="addMessage"
        >
          {{ $t("general.add") }}
        </b-button>
        <div
          class="custom-search mb-0 d-flex"
          style="box-shadow: none; padding: 10px 0"
        >
          
        </div>
      </div>
      <vue-good-table
        class="user-table"
        :columns="columns"
        :rows="allMessages.data"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm,
        }"
        :select-options="{
          selectionInfoClass: 'custom-class',
          selectionText: 'rows selected',
          clearSelectionText: 'clear',
          disableSelectInfo: true, // disable the select info panel on top
          selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
        }"
        :pagination-options="{
          enabled: true,
          perPage: pageLength,
        }"
      >
        <!-- Slot: Table Row -->
        <template slot="table-row" slot-scope="props">
          <!-- Column: Action -->
          <span
            v-if="
              props.column.field === 'mobilesField' &&
              props.row.mobiles.length > 0
            "
          >
            <span
              v-for="(mobile, index) in props.row.mobiles"
              :key="`mobile-${index}`"
              >{{ mobile }}
              <b v-if="index !== props.row.mobiles.length - 1"> - </b></span
            >
          </span>
          <span v-if="props.column.field === 'messageTimeField'">
            <span
              class="badge badge-success"
              v-if="props.row.messageTime === 'the_moment'"
              >در لحظه</span
            >
            <span
              class="badge badge-warning"
              v-else-if="props.row.messageTime === 'regulatory'"
              >زمان بندی</span
            >
          </span>
          <span v-if="props.column.field === 'messageTypeField'">
            {{
              props.row.messageType === "createTurn"
                ? "پیامک بعد از ثبت نوبت"
                : props.row.messageType === "reminderTurn"
                ? "پیامک یادآوری نوبت"
                : props.row.messageType === "moveTurn"
                ? "پیامک جابه جایی نوبت"
                : props.row.messageType === "removeTurn"
                ? "پیامک حذف نوبت"
                : props.row.messageType === "doctorPatientStatTurn"
                ? "پیامک تعداد بیماران فردای هر دکتر"
                : props.row.messageType === "adminTotalPatientStatTomorrowTurn"
                ? "پیامک مدیریتی تعداد بیماران فردای مرکز"
                : props.row.messageType === "patientTomorrowTakenTurn"
                ? "بیماران نوبت گرفته فردا"
                : props.row.messageType === "patientTodayVisited"
                ? "بیماران ویزیت شده امروز"
                : props.row.messageType === "doctorPatientTomorrowTakenTurn"
                ? "دکترهای، بیماران نوبت گرفته فردا"
                : props.row.messageType === "doctorPatientTodayVisited"
                ? "دکترهای، بیماران ویزیت شده روز"
                : ""
            }}
          </span>
          <span v-if="props.column.field === 'action'">
            <span>
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="text-body align-middle mr-25"
                  />
                </template>
                <b-dropdown-item @click="editMessage(props.row)">
                  <feather-icon icon="Edit2Icon" class="mr-50" />
                  <span>{{ $t("general.edit") }}</span>
                </b-dropdown-item>
                <!-- <b-dropdown-item>
                  <feather-icon icon="TrashIcon" class="mr-50" />
                  <span>{{ $t("general.delete") }}</span>
                </b-dropdown-item> -->
              </b-dropdown>
            </span>
          </span>
          <!-- Column: Common -->
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>

        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap">
                {{ $t("general.pageLength") }}
              </span>
              <b-form-select
                v-model="pageLength"
                :options="['20', '50', '100']"
                class="mx-1"
              />
              <span class="text-nowrap">
                {{ $t("general.of") }} {{ allMessages.total }}
                {{ $t("general.pageText2") }}
              </span>
            </div>
            <div>
              <b-pagination
                v-model="page"
                :total-rows="allMessages.total"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
import {
  required,
  requiredIf,
  minLength,
  maxLength,
  sameAs,
} from "vuelidate/lib/validators";
import {
  BBreadcrumb,
  BBreadcrumbItem,
  BRow,
  BCol,
  BDropdown,
  BDropdownItem,
  BButton,
} from "bootstrap-vue";
import Vue from "vue";
import MyAbDatePicker from "@/components/wrapper/datePicker/MyAbDatePicker.vue";
import dateFormat from "@/mixins/dateFormat";
import flatPickr from "vue-flatpickr-component";
import MyVSelect from "@/components/wrapper/select/MyVSelect";
import filterRoles from "@/mixins/filterRoles";

import {
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BAlert,
  BFormCheckbox,
  BCard,
  BCardHeader,
  BCardBody,
  BFormSelectOption,
  BForm,
  BFormRadioGroup,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";

export default {
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BAlert,
    BDropdown,
    BDropdownItem,
    BFormCheckbox,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BFormSelectOption,
    BButton,
    MyAbDatePicker,
    flatPickr,
    required,
    requiredIf,
    minLength,
    maxLength,
    sameAs,
    MyVSelect,
    BForm,
    BFormRadioGroup,
  },
  mixins: [dateFormat, filterRoles],
  data() {
    return {
      content: "",
      messageType: "",
      messageTime: "",
      messageTimeUnit: "",
      mobiles: [],
      users: [],
      doctorRoleId: "",
      doctor: "",
      messageTimeState: "",
      messageTimeValue: "",
      payload: {},
      allMessageTypes: [
        { en: "createTurn", fa: "پیامک بعد از ثبت نوبت" },
        { en: "reminderTurn", fa: "پیامک یادآوری نوبت" },
        { en: "moveTurn", fa: "پیامک جابه جایی نوبت" },
        { en: "removeTurn", fa: "پیامک حذف نوبت" },
        {
          en: "doctorPatientStatTurn",
          fa: "پیامک تعداد بیماران فردای هر دکتر",
        },
        {
          en: "adminTotalPatientStatTomorrowTurn",
          fa: "پیامک مدیریتی تعداد بیماران فردای مرکز",
        },
        { en: "patientTomorrowTakenTurn", fa: "بیماران نوبت گرفته فردا" },
        { en: "patientTodayVisited", fa: "بیماران ویزیت شده امروز" },
        {
          en: "doctorPatientTomorrowTakenTurn",
          fa: "دکترهای، بیماران نوبت گرفته فردا",
        },
        {
          en: "doctorPatientTodayVisited",
          fa: "دکترهای، بیماران ویزیت شده روز",
        },
      ],
      allMessageTime: [
        { en: "the_moment", fa: "در لحظه" },
        { en: "regulatory", fa: "زمان بندی" },
      ],
      allMessageTimeState: [
        { en: "before", fa: "قبل" },
        { en: "after", fa: "بعد" },
      ],
      allMessageTimeUnit: [
        { en: "minute", fa: "دقیقه" },
        { en: "hour", fa: "ساعت" },
        { en: "day", fa: "روز" },
      ],
      allMessages: {},
      pageLength: 20,
      page: 1,
      dir: false,
      columns: [
        {
          label: this.$t("user.messageType"),
          field: "messageTypeField",
        },
        {
          label: this.$t("user.messageTime"),
          field: "messageTimeField",
        },
        {
          label: this.$t("user.mobiles"),
          field: "mobilesField",
        },
        {
          label: this.$t("user.message"),
          field: "content",
        },
        {
          label: this.$t("general.action"),
          field: "action",
        },
      ],
      searchTerm: "",
    };
  },
  methods: {
    searchUser() {
      this.$store.commit("SET_IS_LOADING", true);
      let payload = {
       page: parseInt(this.page),
       limit: parseInt(this.pageLength),
      };
 
      this.$store.dispatch("message/getMessages", payload).then((res) => {
        this.$store.commit("SET_IS_LOADING", false);
        this.pageLength = payload.limit;
        this.allMessages = res;
        this.total = res.length;
      })
    },
    remove(item) {
      this.mobiles.splice(this.mobiles.indexOf(item), 1);
    },
    editMessage(message) {
      this.$router.push({
        name: "editMessage",
        params: { id: message._id },
      });
    },
    addMessage() {
      this.$router.push({
        name: "addMessage",
      });
    },
  },
  computed: {
    breadcrumb() {
      return typeof this.$route.meta.breadCrumb === "function"
        ? this.$route.meta.breadCrumb(this.$route)
        : this.$route.meta.breadCrumb;
    },
    roleFilter: {
      set(role) {
        this.$store.commit("user/SET_ROLE_FILTER", role);
      },
      get() {
        return this.$store.getters["user/roleFilter"];
      },
    },
    statusVariant() {
      const statusColor = {
        Current: "light-primary",
        Professional: "light-success",
        Rejected: "light-danger",
        Resigned: "light-warning",
        Applied: "light-info",
      };
      return (status) => statusColor[status];
    },
  },
  created() {
    this.setBreadcrumbs([
      { text: "homePage", translate: true, to: { name: "home" } },
      { text: "message", to: { name: "manageMessages" }, translate: true },
    ]);
    this.setCurrentBreadcrumb([
      { text: "message", to: { name: "manageMessages" }, translate: true },
    ]);
    this.searchUser()
  },
  watch: {
    page() {
      // if (this.searchTerm) {
      //   this.$store.dispatch("message/getMessages", {
      //     title: this.searchTerm,
      //     page: parseInt(this.page),
      //     limit: parseInt(this.pageLength),
      //   });
      // } else {
        this.searchUser()
      // }
    },
    pageLength() {
      // if (this.searchTerm) {
      //   this.$store.dispatch("medicalSpecialties/searchMedicalSpecialty", {
      //     title: this.searchTerm,
      //     page: parseInt(this.page),
      //     limit: parseInt(this.pageLength),
      //   });
      // }
      // else {
        this.searchUser() // }
    },
  },
};
</script>

<style scoped>
.time-picker .flatpickr-input {
  height: 32px;
}
</style>
